export const OHL = {
    name: 'DV 216 TS OBRENOVAC - TENT A',
    voltage: '220',
    regionCode: 'BGD',
    stanice: [{name: 'OBRENOVAC', position: {lat: 44.6651, lng: 20.1688}}],
    stubovi: [
        { index: 1, name: 'P-01', lat: 44.666 , lng: 20.1681, sys: 1, portal: true },
        { index: 2, name: '1', lat: 44.6668 , lng: 20.1675, sys: 1 },
        { index: 3, name: '2', lat: 44.6676 , lng: 20.1661, sys: 1 },
        { index: 4, name: '3', lat: 44.6691 , lng: 20.1635, sys: 1 },
        { index: 5, name: '4', lat: 44.6701 , lng: 20.1619, sys: 1 },
        { index: 6, name: 'P-04', lat: 44.6705 , lng: 20.1605, sys: 1, portal: true }
    ],
    rasponi: [
        { name: 'P-01 - 1', position: [{ lat: 44.666 , lng: 20.1681 }, { lat: 44.6668 , lng: 20.1675 }] },
        { name: '1 - 2', position: [{ lat: 44.6668 , lng: 20.1675 }, { lat: 44.6676 , lng: 20.1661 }] },
        { name: '2 - 3', position: [{ lat: 44.6676 , lng: 20.1661 }, { lat: 44.6691 , lng: 20.1635 }] },
        { name: '3 - 4', position: [{ lat: 44.6691 , lng: 20.1635 }, { lat: 44.6701 , lng: 20.1619 }] },
        { name: '4 - P-04', position: [{ lat: 44.6701 , lng: 20.1619 }, { lat: 44.6705 , lng: 20.1605 }] }
    ]
}
